const pageCollectionQuery = (path) => `{
  pageCollection(order: [sys_id_ASC], limit: 500, where: { AND: { pageUrl: "${path}" } }) {
    items {
      ...PageFragment
      __typename
    }
    __typename
  }
}

fragment PageFragment on Page {
  pageTitle
  pageUrl
  pageHero {
    ...ImageFragment
    __typename
  }
  pageTemplate
  metaDescription
  metaKeywords
  metaObjects {
    ... on OpenGraphMetaTags {
      ...OpenGraphMetaTagsFragment
      __typename
    }
    ... on TwitterCardMetaTags {
      ...TwitterCardMetaTagsFragment
      __typename
    }
    __typename
  }
  pageContentCollection {
    items {
      ... on Article {
        sys {
          id
          __typename
        }
        ...ArticleFragment
        __typename
      }
      ... on Search {
        sys {
          id
          __typename
        }
        tipsHeader
        tipsBody
        tipsUrl
        headerPhone {
          ...ImageFragment
          __typename
        }
        headerTablet {
          ...ImageFragment
          __typename
        }
        headerDesktop {
          ...ImageFragment
          __typename
        }
        headerHd {
          ...ImageFragment
          __typename
        }
        __typename
      }
      ... on Categorypicker {
        sys {
          id
          __typename
        }
        pluginName
        categoryPicker
        __typename
      }
      ... on Author {
        sys {
          id
          __typename
        }
        ...AuthorFragment
        __typename
      }
      ... on Feature {
        sys {
          id
          __typename
        }
        ...FeatureFragment
        __typename
      }
      ... on Placement {
        sys {
          id
          __typename
        }
        ...PlacementFragment
        __typename
      }
      ... on Post {
        sys {
          id
          __typename
        }
        ...PostFragment
        __typename
      }
      ... on Section {
        sys {
          id
          __typename
        }
        ...SectionFragment
        sectionContentCollection {
          items {
            ... on Feature {
              sys {
                id
                __typename
              }
              ...FeatureFragment
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on Link {
        sys {
          id
          __typename
        }
        ...LinkFragment
        __typename
      }
      ... on YouTubeVideo {
        sys {
          id
          __typename
        }
        ...YouTubeVideoFragment
        __typename
      }
      ... on CallToAction {
        sys {
          id
          __typename
        }
        ...CallToActionFragment
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment ArticleFragment on Article {
  articleTitle
  articlePreamble
  articleBody
  articleTags
  articleAuthor {
    ...AuthorFragment
    __typename
  }
  articleImage {
    ...ImageFragment
    __typename
  }
  __typename
}

fragment AuthorFragment on Author {
  authorName
  authorJobTitle
  authorEmployer
  authorEmail
  authorImage {
    ...ImageFragment
    __typename
  }
  __typename
}

fragment ImageFragment on Asset {
  title
  description
  contentType
  fileName
  size
  url
  width
  height
  __typename
}

fragment FeatureFragment on Feature {
  featureImage {
    ...ImageFragment
    __typename
  }
  featureTitle
  featurePreamble
  featureLink {
    ...LinkFragment
    __typename
  }
  __typename
}

fragment LinkFragment on Link {
  linkText
  linkUrl
  linkType
  linkDescription
  __typename
}

fragment PlacementFragment on Placement {
  placementLabel
  placementId
  placementTargetDevice
  placementWidth
  placementHeight
  __typename
}

fragment YouTubeVideoFragment on YouTubeVideo {
  videoTitle
  videoDescription
  videoId
  __typename
}

fragment CallToActionFragment on CallToAction {
  title
  description
  link {
    ...LinkFragment
    __typename
  }
  __typename
}

fragment PostFragment on Post {
  postTitle
  postType
  postBody
  __typename
}

fragment SectionFragment on Section {
  sectionTitle
  sectionDescription
  sectionBackground
  sectionLink {
    ...LinkFragment
    __typename
  }
  sectionType
  __typename
}

fragment OpenGraphMetaTagsFragment on OpenGraphMetaTags {
  openGraphUrl
  openGraphTitle
  openGraphSiteName
  openGraphDescription
  openGraphType
  openGraphLocale
  openGraphImage {
    ...ImageFragment
    __typename
  }
  __typename
}

fragment TwitterCardMetaTagsFragment on TwitterCardMetaTags {
  twitterCard
  twitterTitle
  twitterSite
  twitterDescription
  twitterImage {
    ...ImageFragment
    __typename
  }
  __typename
}


`

const menuCollectionQuery = (title) => `{
menuCollection(order: [sys_id_ASC], limit: 500, where: { AND: { title: "${title}" } }) {

    items {
      ...MenuFragment
      __typename
    }
    __typename
  }
}

fragment MenuFragment on Menu {
  title
  type
  sys {
    id
    __typename
  }
  contentCollection {
    items {
      ... on MenuSection {
        ...MenuSectionFragment
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment MenuSectionFragment on MenuSection {
  title
  url
  sys {
    id
    __typename
  }
  contentCollection {
    items {
      ... on MenuItem {
        ...MenuItemFragment
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment MenuItemFragment on MenuItem {
  title
  url
  sys {
    id
    __typename
  }
  __typename
}
`

export default {
  pageCollectionQuery,
  menuCollectionQuery,
}
